function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeNutrientNeutrality({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.69L17.66 8.35C18.7794 9.46861 19.5418 10.8941 19.8509 12.4461C20.16 13.998 20.0019 15.6069 19.3965 17.069C18.7912 18.5311 17.7658 19.7808 16.4501 20.6601C15.1344 21.5394 13.5875 22.0087 12.005 22.0087C10.4225 22.0087 8.87561 21.5394 7.5599 20.6601C6.24419 19.7808 5.21882 18.5311 4.61347 17.069C4.00812 15.6069 3.85 13.998 4.15911 12.4461C4.46822 10.8941 5.23066 9.46861 6.35001 8.35L12 2.69Z",
    stroke: "#3BA6BF",
    style: {
      stroke: "#3BA6BF",
      stroke: "color(display-p3 0.2314 0.6510 0.7490)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeNutrientNeutrality);
export default __webpack_public_path__ + "static/media/project-type-nutrient-neutrality.aea854e054bc9ed2b3e20057d61d010c.svg";
export { ForwardRef as ReactComponent };